import * as theme from "../theme";

import { useContext } from "react";
import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import CustomInput from "../components/inputs/CustomInput";
import InputContainer from "../components/inputs/InputContainer";
import Context from "../contexts/data";
import { onlyLetter } from "../util/regex";

const UserName = () => {
  const { firstName, lastName, errorMessage, handleUpdateFormValue, navigate } =
    useContext(Context);

  const handleNextStep = () => {
    if (!firstName || firstName.length <= 2) {
      handleUpdateFormValue(
        "errorMessage",
        "Please enter your first name (at least two letters)."
      );
      return;
    }

    if (!lastName || lastName.length <= 2) {
      handleUpdateFormValue(
        "errorMessage",
        "Please enter your last name (at least two letters)."
      );
      return;
    }

    navigate("email", "Full Name");
  };

  const handleUpdate = (e) => {
    const { value, name } = e.target;

    if (onlyLetter.test(value) || !value) {
      handleUpdateFormValue(name, value);
    }
  };

  return (
    <Wrapper>
      <HeaderText
        bigger_text={"What is your name?"}
        smaller_text={"Your personal information is safe and secure."}
      />
      <InputContainer inputClass={"multiInput"}>
        <CustomInput
          errorMessage={errorMessage && !firstName && firstName.length <= 2}
          name={"firstName"}
          onChange={handleUpdate}
          placeholder="First Name"
          value={firstName}
          fieldClass={"twoInputs"}
          labelName={"First Name"}
        />
        <CustomInput
          errorMessage={errorMessage && !lastName && lastName.length <= 2}
          name={"lastName"}
          onChange={handleUpdate}
          placeholder="Last Name"
          value={lastName}
          fieldClass={"twoInputs"}
          labelName={"Last Name"}
        />
      </InputContainer>
      <ErrorMessage />
      <Button onClick={handleNextStep} />
    </Wrapper>
  );
};

const Wrapper = styled(theme.column_align)`
  @media (max-width: ${theme.mobile}) {
    margin-bottom: 16px;
  }
`;

export default UserName;
